import React from "react";

interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({
  icon,
  title,
  action,
  children,
}) => (
  <div className="or-section-card">
    <div className="or-section-header">
      <span className="or-section-header-left">
        {icon}
        <span className="or-section-title">{title}</span>
      </span>
      {action}
    </div>
    {children}
  </div>
);

export default SectionCard;
